<template>
  <v-toolbar v-bind="$attrs" v-on="$listeners">
    <!-- Pass on all named slots -->
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
      ><slot :name="slot" v-bind="scope"
    /></template>
  </v-toolbar>
</template>

<script>
export default {
  name: "AToolbar",
};
</script>

<style scoped>
::v-deep .v-toolbar__title {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
}
::v-deep .v-toolbar__content,
.v-toolbar__extension {
  padding: 0px 0px !important;
}
.primary-gradient {
  color: white !important;
  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.08) 100%
    ),
    #006cad !important;
  font-weight: 700 !important;
  height: 48px !important;
}
.grey-gradient {
  color: rgba(0, 0, 0, 0.87) !important;
  background: #dddddd !important;
  font-weight: 700 !important;
  height: 48px !important;
  box-shadow: none !important;
}
.primary-gradient /deep/ .v-toolbar__content {
  height: 48px !important;
  line-height: 48px !important;
}
.grey-gradient /deep/ .v-toolbar__content {
  height: 48px !important;
  line-height: 48px !important;
}
.primary-gradient /deep/ .theme--light.v-btn {
  color: #fff !important;
}
.grey-gradient /deep/ .theme--light.v-btn {
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>